import React, { Component, Fragment } from 'react';
import authService, { AuthenticationResultStatus } from './AuthorizeService';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: undefined,
            isLoading: true
        };
    }

    componentDidMount() {
        const action = this.props.action;
        switch (action) {
            case 'login':
                this.login(this.getReturnUrl());
                break;
            case 'login-callback':
                this.processLoginCallback();
                break;
            case 'login-failed':
                const params = new URLSearchParams(window.location.search);
                const error = params.get('message');
                this.setState({ 
                    message: error || 'Login failed. Please try again.',
                    isLoading: false 
                });
                break;
            default:
                throw new Error(`Invalid action '${action}'`);
        }
    }

    async login(returnUrl) {
        try {
            const state = { returnUrl };
            const result = await authService.signIn(state);
            
            // Add null check
            if (!result) {
                this.setState({ 
                    message: 'Authentication service returned no result. Please check your configuration.',
                    isLoading: false 
                });
                return;
            }
            
            switch (result.status) {
                case AuthenticationResultStatus.Redirect:
                    // Redirecting to login
                    break;
                case AuthenticationResultStatus.Success:
                    await this.navigateToReturnUrl(returnUrl);
                    break;
                case AuthenticationResultStatus.Fail:
                    this.setState({ 
                        message: result.message || 'Login failed. Please try again.',
                        isLoading: false 
                    });
                    break;
                default:
                    throw new Error(`Invalid authentication result status '${result.status}'.`);
            }
        } catch (error) {
            console.error('Login error:', error);
            this.setState({ 
                message: `An unexpected error occurred during login: ${error.message || 'Unknown error'}`,
                isLoading: false 
            });
        }
    }

    async processLoginCallback() {
        try {
            const url = window.location.href;
            console.log('Processing login callback for URL:', url);
            
            const result = await authService.completeSignIn(url);
            
            // Add null check for result
            if (!result) {
                console.error('completeSignIn returned undefined result');
                this.setState({ 
                    message: 'Authentication service returned no result. Please check your identity provider configuration and network connectivity.',
                    isLoading: false 
                });
                return;
            }

            console.log('Login callback result:', result);
            
            switch (result.status) {
                case AuthenticationResultStatus.Redirect:
                    throw new Error('Should not redirect after callback.');
                case AuthenticationResultStatus.Success:
                    await this.navigateToReturnUrl(this.getReturnUrl(result.state));
                    break;
                case AuthenticationResultStatus.Fail:
                    this.setState({ 
                        message: result.message || 'Login callback failed.',
                        isLoading: false 
                    });
                    break;
                default:
                    throw new Error(`Invalid authentication result status '${result.status}'.`);
            }
        } catch (error) {
            console.error('Login callback error:', error);
            this.setState({ 
                message: `There was an error processing the login callback: ${error.message || 'Unknown error'}. Please check browser console for details.`,
                isLoading: false 
            });
        }
    }

    getReturnUrl(state) {
        const params = new URLSearchParams(window.location.search);
        const fromQuery = params.get('returnUrl');
        if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
            throw new Error("Invalid return url. The return url needs to have the same origin as the current page.");
        }
        return (state && state.returnUrl) || fromQuery || `${window.location.origin}/`;
    }

    navigateToReturnUrl(returnUrl) {
        return window.location.replace(returnUrl);
    }

    render() {
        const { message, isLoading } = this.state;

        if (isLoading) {
            return <div>Loading...</div>;
        }

        if (message) {
            return (
                <div className="alert alert-danger" role="alert">
                    {message}
                </div>
            );
        }

        return <Fragment></Fragment>;
    }
}
